export const TEST = 'TEST';
export const TARIFFS = 'TARIFFS';
